import { gql } from "@apollo/client";
import moment from "moment";

export const GET_PACIENTE_PROBABLE_EXPORT = gql`
query GetAllPrePaciente( $where: PrePacienteFilterInput ) {
    allPrePacienteExport( where: $where)
    {
            idDelegacionNavigation {
                idRegionNavigation {
                    descripcion
                }
                descripcion
            }
            codInstitucionNavigation {
                nombre
                cod_Institucion
            }
            nombre
            apellido
            idTipoDocumentoNavigation {
                descripcion
            }
            nroDocumento
            fechaNacimiento
            sexo
            telPaciente
            nombreFamiliar
            telFamiliar
            financiador
            referente
            idTipoModuloNavigation {
                abreviacion
            }
            idEstadoNavigation{
                nombre
            }
            fechaAltaProbable
            idUsuarioAltaNavigation {
                nombre
                apellido
            }
            fechaAlta
            idUsuarioModificacionNavigation {
                nombre
                apellido
            }
            fechaModificacion
            observacion
    }
}`;

export const adaptPrePacienteExportArray = (
    prePacienteExport) =>
    prePacienteExport?.map((pp) => ({
        region: pp?.idDelegacionNavigation?.idRegionNavigation?.descripcion || '-',
        delegacion: pp?.idDelegacionNavigation?.descripcion || '-',
        institucion: pp?.codInstitucionNavigation ?
            (pp?.codInstitucionNavigation?.cod_Institucion || '') + ' - ' + (pp?.codInstitucionNavigation?.nombre || '') :
            '-',
        nombre: pp?.nombre || '-',
        apellido: pp?.apellido || '-',
        tipoDocumento: pp?.idTipoDocumentoNavigation?.descripcion || '-',
        nroDocumento: pp?.nroDocumento || '-',
        fechaNacimiento: pp?.fechaNacimiento ? moment(pp?.fechaNacimiento).format('DD/MM/YYYY') : '-',
        sexo: pp?.sexo || '-',
        //\u200B is a zero-width space to force Excel to treat the cell as text
        telPaciente: pp?.telPaciente ? `\u200B${pp?.telPaciente}` : '-',
        nombreFamiliar: pp?.nombreFamiliar || '-',
        telFamiliar: pp?.telFamiliar ? `\u200B${pp?.telFamiliar}` : '-',
        financiador: pp?.financiador || '-',
        referente: pp?.referente || '-',
        programa: pp?.idTipoModuloNavigation?.abreviacion || '-',
        estado: pp?.idEstadoNavigation?.nombre || '-',
        fechaAltaProbable: pp?.fechaAltaProbable ? moment(pp?.fechaAltaProbable).format('DD/MM/YYYY') : '-',
        usuarioAlta: pp?.idUsuarioAltaNavigation?.apellido + ', ' + pp?.idUsuarioAltaNavigation?.nombre,
        fechaAlta: pp?.fechaAlta ? moment(pp?.fechaAlta).format('DD/MM/YYYY') : '-',
        usuarioModificacion: pp?.idUsuarioModificacionNavigation?.apellido + ', ' + pp?.idUsuarioModificacionNavigation?.nombre,
        fechaModificacion: pp?.fechaModificacion ? moment(pp?.fechaModificacion).format('DD/MM/YYYY') : '-',
        observacion: pp?.observacion || '-'
    })
    );